import React, { useEffect } from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import TestsRequests from "services/tests";
import WGETableHeading from "./WGETableHeading";
import WGETableItem from "./WGETableItem";

const WGETable = ({ searchMode, searchInput }) => {
    const dispatch = useDispatch();
    const { wgevents, wgeventsCurrentPage, wgeventsTotalPage } = useSelector(
      ({ tests }) => tests
    );
  
    useEffect(() => {
      if (searchMode) {
        dispatch(TestsRequests.getWGEvents(1, searchInput));
      } else {
        dispatch(TestsRequests.getWGEvents(1));
      }
    }, [searchInput, searchMode]);
  
    const handleChangePagination = (_, value) => {
      if (searchMode) {
        dispatch(TestsRequests.getWGEvents(value, searchInput));
      } else {
        dispatch(TestsRequests.getWGEvents(value));
      }
    };
  
    return (
      <div className="Cmt-table-responsive">
        {wgevents &&
          (wgevents.length === 0 ? (
            <Box
              display={"flex"}
              justifyContent={"center"}
              paddingTop={"30px"}
              paddingBottom={"20px"}
            >
              <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
            </Box>
          ) : (
            <Table>
              <TableHead>
                <WGETableHeading />
              </TableHead>
              <TableBody>
                {wgevents.map((item) => (
                  <WGETableItem
                    data={item}
                    key={item._id}
                    id={item._id}
                  />
                ))}
              </TableBody>
            </Table>
          ))}
        {wgevents.length !== 0 ? (
          <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
            <Pagination
              count={wgeventsTotalPage}
              color="primary"
              page={wgeventsCurrentPage}
              onChange={handleChangePagination}
            />
          </Box>
        ) : null}
      </div>
    );
  };
  
  export default WGETable;